import React from 'react';
import moment from 'moment';


type TFreelancerInterviewStatementsProps = {
    interviewer: string;
    interviewDate: string;
    hasSignedContract: boolean;
    identityConfirmed: boolean;
}

export default function FreelancerInterviewStatements({
    interviewer,
    interviewDate,
    hasSignedContract,
    identityConfirmed,
}:TFreelancerInterviewStatementsProps) {
    const fullDate = new Date(interviewDate);
    const date = moment(fullDate).format('D MMM YYYY');
    const time = moment(fullDate).format('h:mm a');

    return (
        <div>
            {hasSignedContract && (
            <div className="freelancer-details-section__content text-align-center">
                {interviewer} checked that this worker has signed their Contract for Services on {date} at {time}.
            </div>
            )}
            {identityConfirmed && (
            <div className="freelancer-details-section__content text-align-center">
                {interviewer} confirmed that the likeness of the person matched their documentation provided on {date} at {time}.
            </div>
            )}
        </div>
    );
}
